import React, { createContext, useEffect, useState } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import Sidenav from "./components/Sidenav/Sidenav";
import Navbar from "./components/Navbar/Navbar";
import Dashboard from "./components/Dashboard/Dashboard";
import Login from "./components/Auth/logIn";
import Profile from "./components/profile/Profile";
import AboutUs from "./components/aboutus/AboutUs";
import Terms from "./components/terms/Terms";
import Query from "./components/query/Query";
import Projects from "./components/Projects/Projects";
import PrivacyPolicy from "./components/privacyPolicy/PrivacyPolicy";
import Equipment from "./components/Equipment/Equipment";
import SubContractor from "./components/SubContractor/SubContractor";
import AssignedProjects from "./components/Projects/AssignedProjects";
import Invoice from "./components/Invoice/invoice";
import { getAccessTokenFromRefreshToken } from "./webServices/Apis";
import ArchivedInvoices from "./components/Invoice/ArchivedInvoices";
import Chat from "./components/chat/chat";
import PrintInvoice from "./components/Invoice/PrintInvoice";
import AuthAccess from "./components/Authorize Access/AuthAccess";
import ActiveSubContractors from "./components/Dashboard/ActiveSubContractors";
import InactiveSubContractors from "./components/Dashboard/InactiveSubContractors";
import PrivacyPolicyForLive from "./components/P&P/PrivacyPolicyForLive";
import SupportStaff from "./components/Support Staff/SupportStaff";
import ArchivedProjects from "./components/Projects/ArchivedProjects";
import PrintMultiple from "./components/Invoice/PrintMultipleInvoice";
import { message } from "antd";

import { getProfile } from "./webServices/Apis";

// Step 1: Create UserContext outside App
export const UserContext = createContext();

const App = () => {
  
  const [isOpen, setIsOpen] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(() =>
    localStorage.getItem("token")  ? true : false
  );

  const toggleSidenav = () => {
    setIsOpen((prev) => !prev);
  };


 

  // const getAllDomains = async () => {
  //   try {
  //     const res = await getDomain();
  //     if (res?.data?.success) {
  //       setDomains(res?.data?.data);
  //     }
  //   } catch (error) {
  //     if (error?.response?.status === 401 || error?.response?.status === 500) {
  //       localStorage.removeItem("token");
  //       setIsAuthenticated(false);
  //     }
  //   }
  // };

 



  return (
    <Router >
      <UserContext.Provider value={{ setIsAuthenticated, isAuthenticated }}>
        {isAuthenticated ? (
          <AuthenticatedApp
            isOpen={isOpen}
            toggleSidenav={toggleSidenav}

          />
        ) : (
          <Routes>
            <Route path="livePrivacy" element={<PrivacyPolicyForLive />} />
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        )}
      </UserContext.Provider>
    </Router>
  );
};

const AuthenticatedApp = ({ isOpen, toggleSidenav }) => {

  const [adminProfile, setAdminProfile] = useState([])

  const location = useLocation(); // Now inside the Router context
  const path = location.pathname;

  // Parse query parameters
  const queryParams = new URLSearchParams(location.search);
  const accessToken = queryParams.get("access_token");
  const refreshToken = queryParams.get("refresh_token");
  const currentTime = Date.now();
  const expirationTime = currentTime + 3600000;

  const qbKey = localStorage.getItem("qbKey")

  if (accessToken && refreshToken) {
    localStorage.setItem("access_token", accessToken);
    localStorage.setItem("refresh_token", refreshToken);
    localStorage.setItem("token_expiration_time", expirationTime);
  }

  const getNewAccessToken = async () => {
    try{
      if (localStorage.getItem("refresh_token")) {
        if (Date.now() > localStorage.getItem("token_expiration_time")) {
          const refToken = localStorage.getItem("refresh_token")
          const refreshedAccessToken = await getAccessTokenFromRefreshToken(refToken)
          if (refreshedAccessToken?.data?.success) {
            console.log("Acess token refreshed successfully")
            localStorage.setItem("access_token", refreshedAccessToken?.data?.data)
            localStorage.setItem("token_expiration_time", Date.now() + 3600000)
            return;
          }
        }
        else {
          console.log("Access token stored is still valid")
          return;
        }
      } else { return;}
    } catch (error) {
      console.log("error while token refreshing", error.message)
      if(error?.response?.status === 401 || error?.response?.status === 500){
        window.alert("Session Timeout !")
        localStorage.clear()
        window.location.href="/login"
        return ; 
      }
    }
    
  }


  const fetchProfile = async () => {
    try {
       if (!localStorage.getItem("token")) {
              return;
            }
            const response = await getProfile();
      
            if (response?.data?.success) {
              setAdminProfile(response?.data?.data);
            }

    } catch (error) {

      if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
                   message.error("Network Error")
                    return;
                  }
                  // Handle specific error cases
                  if (error?.response?.status === 401 ) {
                    window.alert("Your account is logged in to another device, please login again !")
                    localStorage.removeItem('token');
                    // setIsAuthenticated(false)
                    window.location.href = "/login";
                    return;
                  }
                  if (error?.response?.status === 500){
                    message.error("Server not responding")
                    return;
                  }
                  if (error?.response?.status === 403){
                    window.alert("Your subcription has been expired")
                    localStorage.clear()
                    // setIsAuthenticated(false) 
                    window.location.href = "/login";
                    return;
                  }
                  else {
                    return;
                  }
      
    }
  }

  useEffect(() => {
    fetchProfile();
  }, []);

  useEffect(() => {

    if(qbKey === true){
      const storedAccessToken = localStorage.getItem("access_token")
      const storedRefreshToken = localStorage.getItem("refresh_token")

        if(!storedAccessToken || !storedRefreshToken){
          message.error("Quick Books authentication failed !")
          localStorage.clear();
          window.location.href="/login";
          return;
        }

    }

    getNewAccessToken()

  }, [location]);




  return (
    <div className="flex h-screen">
      {(path !== "/print-invoice" || path !== "/print-all-invoice") && <Sidenav isOpen={isOpen } admin={adminProfile} />}
      <div
        className={`flex-1 transition-all duration-300 ${isOpen ? "ml-64" : "ml-0"
          }`}
      >
        {(path !== "/print-invoice" || path !== "/print-all-invoice") && <Navbar toggleSidenav={toggleSidenav} />}
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/query" element={<Query />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/assigned-project" element={<AssignedProjects />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/equipments" element={<Equipment />} />
          <Route
            path="/subcontractor"
            element={<SubContractor />}
          />
          <Route path="/active" element={<ActiveSubContractors />} />
          <Route path="/inactive" element={<InactiveSubContractors />} />
          <Route path="/invoice" element={<Invoice />} />
          <Route path="/archived-invoices" element={<ArchivedInvoices />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/print-invoice" element={<PrintInvoice />} />
          <Route path="/authorize-access" element={<AuthAccess />} />
          <Route path="/support-staff" element={<SupportStaff />} />
          <Route path="/archived-projects" element={<ArchivedProjects />} />
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/print-all-invoice" element={<PrintMultiple />} />
        </Routes>
      </div>
    </div>
  );
};

export default App;
